import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import {
  setHasServicesForClient,
  selectChildForServices,
} from '../../data/client/ClientActions.js';
import {
  getIsFamilyMemberAccount,
  getFamilyMemberTerm,
  getShortFamilyMemberTerm,
  getIsServiceAvailableForClient,
} from '../../data/app/AppReducer.js';
import {
  ClientPerson,
  Circle,
  CircleCheck,
  Backdrop,
  ActionButton,
  ActionButtonSecondary,
} from '../../components/Themed.js';
import './ClientPersonSelection.css';
import { t } from '../../locales';

class ClientPersonSelection extends React.Component {
  constructor(props) {
    super(props);

    this.renderPerson = this.renderPerson.bind(this);
  }

  renderPerson(firstName, lastName, clientId, childId, selected, onClick) {
    return (
      <ClientPerson
        key={clientId + '_' + childId}
        className={childId ? 'client-person-selection-child' : ''}
        selected={selected}
        onClick={onClick}
      >
        <Circle>
          <CircleCheck
            className="fas fa-check"
            style={{
              opacity: selected ? 1 : 0,
            }}
          />
        </Circle>
        <div className="client-person-selection-text">
          {firstName + (lastName ? ' ' + lastName : '')}
        </div>
      </ClientPerson>
    );
  }
  render() {
    const {
      clientInformation,
      childrenSelectedForServices,
      hasServicesForClient,
      setHasServicesForClient,
      selectChildForServices,
      isFamilyMemberAccount,
      familyMemberTerm,
      shortFamilyMemberTerm,
      isServiceAvailableForClient,
      mustSelectChild,
    } = this.props;

    const selectedCount =
      childrenSelectedForServices.length + (hasServicesForClient ? 1 : 0);

    if (
      !isFamilyMemberAccount &&
      clientInformation.children &&
      (clientInformation.children.length === 0 ||
        !clientInformation.children[0].id)
    ) {
      return (
        <React.Fragment>
          <Backdrop id="backdrop" />
          <div className="scroll-container content-container">
            <div className="page-container">
              <Redirect to="/services/0" />
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="return-client">
              <div className="client-person-selection-title">
                {t('client_person_selection.welcome_to')}{' '}
                {clientInformation.first_name}!
                <br />
                {t('client_person_selection.who_is_checking-in_today')}
              </div>
              <div className="content content-padding">
                <div className="client-person-selection-container">
                  {isServiceAvailableForClient && !mustSelectChild &&
                    this.renderPerson(
                      clientInformation.first_name,
                      clientInformation.last_name,
                      clientInformation.id,
                      null,
                      hasServicesForClient,
                      () => setHasServicesForClient(!hasServicesForClient)
                    )}
                  {clientInformation.children.map(c => {
                    if (!c.id) return null;

                    const selected =
                      childrenSelectedForServices.indexOf(c.id) > -1;

                    return this.renderPerson(
                      c.first_name,
                      c.last_name,
                      c.client_id,
                      c.id,
                      selected,
                      () => selectChildForServices(c.id, !selected)
                    );
                  })}
                </div>

                {isFamilyMemberAccount && (
                  <Link to="/newFamilyMember">
                    <ActionButtonSecondary>
                      + {t('client_person_selection.add_new')}{' '}
                      {familyMemberTerm}
                    </ActionButtonSecondary>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        {selectedCount > 0 && (
          <div className="client-person-selection-controls">
            <div className="client-person-selection-controls-summary">
              {selectedCount} {shortFamilyMemberTerm}
              {selectedCount > 1 ? 's' : ''}{' '}
              {t('client_person_selection.selected')}
            </div>
            <Link to="/services/0">
              <ActionButton className="client-person-selection-controls-button">
                {t('client_person_selection.continue')}
              </ActionButton>
            </Link>
          </div>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    clientInformation: state.client.clientInformation,
    companyName: state.app.businessInfo.company.name,
    hasServicesForClient: state.client.hasServicesForClient,
    childrenSelectedForServices: state.client.childrenSelectedForServices,
    isFamilyMemberAccount: getIsFamilyMemberAccount(state.app.businessInfo),
    familyMemberTerm: getFamilyMemberTerm(state.app.businessInfo),
    shortFamilyMemberTerm: getShortFamilyMemberTerm(state.app.businessInfo),
    isServiceAvailableForClient: getIsServiceAvailableForClient(
      state.app.businessInfo
    ),
    mustSelectChild: state.app.businessInfo.company.must_select_child,
  };
}

export default connect(
  mapStateToProps,
  { setHasServicesForClient, selectChildForServices }
)(ClientPersonSelection);
